import './hto.scss';
import React, { useEffect, useRef, useState } from 'react';
import { provideHooks } from 'redial';
import { connect } from 'react-redux';
import config from '../../../../config';
import Helmet from 'react-helmet';

// actions
import { getHTOConfig, bookHTOAppointment } from '../../../../actionCreators/hto';
import { addToCart, updateCart, getCart, deleteCart, updateCartItem, applyCode } from '../../../../actionCreators/cart';
import localStorageHelper from '../../../../utils/localStorageHelper';
import { orderPayment } from '../../../../actionCreators/checkout';
import { showGlobalHeaderFooter } from '../../../../actionCreators/header';
import { noop } from '../../../../utils/helper';
import getSetCookie from '../../../../cookie';
import { setToastMessage } from '../../../../actionCreators/common';
import { getOrder } from '../../../../actionCreators/order';

// components
import Loader from '../../../Loader/Loader';
import HTOHome from '../HTOHome/HTOHome';
import HTOAppointmentLocation from '../../containers/HTOLocationView/HTOAppointmentLocation';
import HTOScheduleLater from '../../containers/HTOScheduleLater/HTOScheduleLater';
import HTOAppointment from '../../components/HTOAppointment/HTOAppointment';
import HTOCancelAppointmentSuccess from '../../components/HTOCancelAppointmentSuccess/HTOCancelAppointmentSuccess';
import HTOAppointmentSuccess from '../../components/HTOAppointmentSuccess/HTOAppointmentSuccess';
import HTOCancelAppointment from '../../components/HTOCancelAppointment/HTOCancelAppointment';
import InfoModalComponent from '../../../../desktop/components/Common/InfoModalComponent';
import Customevent from '../../../../utils/Customevent';

let Modal, modalConfig, isMobile, isCartAddOrUpdate = false; // eslint-disable-line
'#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
Modal = require('../../../../desktop/components/Modal/Modal').default;
modalConfig = { backdrop: 'static', showModal: true, dialogClassName: 'hto modal-center' };
isMobile = false;
'#endif'; // eslint-disable-line
'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
Modal = require('../../../../mobile/components/BottomSheet/BottomSheet').default;
modalConfig = { backdrop: true, expanded: true };
isMobile = true;
'#endif'; // eslint-disable-line


const hooks = {
    fetch: ({ store: { dispatch, getState } }) => {
        const state = getState();
        if (!state.hto.htoConfig) {
            dispatch(getHTOConfig());
        }
    },
    defer: ({ store: { dispatch, getState } }) => {
        dispatch(showGlobalHeaderFooter({ header: false, footer: false }));
        const cartId = getState().cart.cartData.result.cartId;
        if (!cartId) dispatch(getCart(null, false));
        // In case of user coming from payu page
        if (__CLIENT__ && document.referrer.indexOf('secure.payu') > 0) {
            const dataBookLater = JSON.parse(localStorage.getItem('htoBookLaterData'));
            // PP 1910182876, normal 1910184001
            dispatch(getOrder({ orderId: getSetCookie.getCookie('orderId'), dontInitSession: true, email: dataBookLater.email }));
            getSetCookie.deleteCookie('orderId');
        }
    }
};

function HTO(props) {
    const paymentForm = useRef(null);
    const [hash, setHash] = useState();
    // const [paymentErrorMsg, setPaymentErrorMsg] = useState();
    const [isOnlinePayment, setisOnlinePayment] = useState(false);
    const [errorMsg, setErrorMsg] = useState();
    // const navTo = hash => setHash(`${hash ? `#${hash}` : ''}`);
    const navTo = (hash, currHash) => {
        if (currHash === '#book-later' && props.cartData.items.length) props.resetCartItem(props.cartData.items[0].id, 1, 'decrease');
        setHash(`${hash ? `#${hash}` : ''}`);
    };

    const scheduleOrUpdate = (appointmentType, data = {}) => {
        '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
        props.setToastMessage({});
        '#endif'; // eslint-disable-line
        '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
        setErrorMsg('');
        '#endif'; // eslint-disable-line
        const address = localStorageHelper.getItem('htoAddress');
        const appointment = address[appointmentType];
        localStorageHelper.setItem('appointmentType', appointmentType);
        const itemId = props.cartData.items[0] && props.cartData.items[0].id;
        const today = new Date();
        const hto = {
            date: data.date ? data.date : `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`,
            city: address.city,
            slotId: data.slot || appointment.slotObjectId
        };
        if (appointmentType === 'bookNow') {
            navTo('book-now');
        } else if (itemId && props.cartData.cartType === 'HEC') {
            isCartAddOrUpdate = true;
            props.updateCart(itemId, { hto });
        } else {
            isCartAddOrUpdate = true;
            props.addToCart({ hto, productId: 47552 });
        }
    };

    const placeOrder = (paymentType, user = {}, cartTotal) => {
        const data = localStorageHelper.getItem('htoAddress');
        const htoBookLaterData = localStorageHelper.getItem('htoBookLaterData');
        const billingAddress = {
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            phone: data.phone,
            email: user.email || '',
            addressline1: user.addressline1 || data.formattedAddress,
            addressline2: user.addressline2,
            city: data.city || (props.pincodeData && props.pincodeData.city),
            state: data.state || (props.pincodeData && props.pincodeData.state),
            country: 'IN',
            postcode: data.bookLater && data.bookLater.postcode,
            addressType: htoBookLaterData.addressType
        };
        let device = 'desktop';
        // Handling for case where 100% gv is applied with COD/Online
        let payMethod = 'pm';
        if (cartTotal === 0) payMethod = 'gv';
        else if (paymentType === 'cod') payMethod = 'cod';
        '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
        device = 'mobile';
        '#endif'; // eslint-disable-line
        props.placeOrder({
            billingAddress,
            device,
            paymentInfo: {
                paymentMethod: payMethod
            }
        });
    };
    const utmZ = getSetCookie.getCookie('__utmz');
    const bookAppointmentNow = () => {
        const data = localStorageHelper.getItem('htoAddress');
        const userInfo = {
            firstName: data.phone,
            lastName: 'user',
            telephone: data.phone,
            email: `${data.phone}@lenskart.in`,
            location: `${data.lat}, ${data.lng}`
        };
        props.bookAppointment(userInfo, `?utm_source=${utmZ}`);
    };

    const prevPaymentData = useRef(props.paymentData);
    useEffect(() => {
        if (prevPaymentData !== props.paymentData && props.paymentData) {
            const { order, payment, msg } = props.paymentData || {};
            getSetCookie.setCookie('orderId', order.id, 0.0625);
            props.deleteCart();
            const event = new Customevent('htoOrderSuccess', { detail: { order_id: order.id, cartPrice: order.amount.total, saleSrc: utmZ } });
            setTimeout(() => event.dispatch(event), 80);
            if (!payment && msg) {
                navTo('confirm-appointment');
                // '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
                //  props.setToastMessage({ message: msg });
                // '#endif'; // eslint-disable-line
                // '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                // setErrorMsg(msg);
                // // setPaymentErrorMsg(msg);
                // '#endif'; // eslint-disable-line
                return;
            }
            if (payment.actionInfo.action === 'DONE') {
                navTo('confirm-appointment');
            } else {
                paymentForm.current.submit();
            }
        }
    }, [props.paymentData]);

    const prevcartDataErr = useRef(null);
    useEffect(() => {
        if (prevcartDataErr !== props.cartDataErr && props.cartDataErr && isCartAddOrUpdate) {
            '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
            props.setToastMessage({ message: props.cartDataErr.message });
            '#endif'; // eslint-disable-line
            '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
            setErrorMsg(props.cartDataErr.message);
            '#endif'; // eslint-disable-line
        }
        isCartAddOrUpdate = false;
    }, [props.cartDataErr]);

    const prevPaymentError = useRef(props.paymentError);
    useEffect(() => {
        if (prevPaymentError !== props.paymentError && props.paymentError) {
            const message = props.paymentError && props.paymentError.message || 'Something went wrong, Please try again!!';
            '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
            setErrorMsg(message);
            // setPaymentErrorMsg(message);
            '#endif'; // eslint-disable-line
            '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
            props.setToastMessage({ message });
            '#endif'; // eslint-disable-line
        } else {
            '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
            setErrorMsg('');
            // setPaymentErrorMsg('');
            '#endif'; // eslint-disable-line
        }
    }, [props.paymentError]);

    const prevAppointmentInfo = useRef(props.appointmentInfo);
    useEffect(() => {
        if (prevAppointmentInfo !== props.appointmentInfo) {
            const { appointmentInfo } = props;
            if (appointmentInfo) {
                if (appointmentInfo.success) {
                    navTo('confirm-appointment');
                    '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                    setErrorMsg('');
                    '#endif'; // eslint-disable-line
                    window.goog_report_conversion();
                    const event = new Customevent('htoOrderSuccess', { detail: { order_id: appointmentInfo.orderid, cartPrice: appointmentInfo.cartPrice, saleSrc: utmZ } });
                    setTimeout(() => event.dispatch(event), 80);
                } else if (appointmentInfo.error || appointmentInfo.message) { // Todo: Need to remove message object
                    const message = appointmentInfo.error || appointmentInfo.message || 'Something went wrong, Please try again!!';
                    '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                    setErrorMsg(message);
                    '#endif'; // eslint-disable-line
                    '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
                    props.setToastMessage({ message });
                    '#endif'; // eslint-disable-line
                }
            } else {
                '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                setErrorMsg('');
                '#endif'; // eslint-disable-line 
            }
        }
    }, [props.appointmentInfo]);

    const prevOrderDetail = useRef(props.orderDetail);
    useEffect(() => {
        if (prevOrderDetail !== props.orderDetail) {
            if (props.orderDetail) {
                navTo('confirm-appointment');
                setisOnlinePayment(true);
                window.goog_report_conversion();
            }
        }
    }, [props.orderDetail]);

    if (!props.htoConfig) return <Loader fullpage />;

    '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
    if (hash === '#book-later') {
        modalConfig = { ...modalConfig, size: 'large', dialogClassName: 'hto hto-book-later' };
    } else if (hash === '' || hash === undefined && __CLIENT__) {
        getSetCookie.deleteCookie('orderId');
    } else {
        delete modalConfig.size;
        modalConfig.dialogClassName = 'hto';
    }
    '#endif'; // eslint-disable-line
    const payment = props.paymentData ? props.paymentData.payment : null;
    const order = props.paymentData ? props.paymentData.order : null;
    const appointmentInfo = props.appointmentInfo;

    return (
        <div className="hto">
            <HTOHome active={!hash} navTo={navTo} />
            <Helmet
                title="Eye Test: Book Eye Checkup at Home | Eye Sight Test at Home | Lenskart"
                meta={[
                    { name: 'description', content: 'Get your eye vision checked at home from certified opticians/ophthalmologists. Complete eye examination from the comfort of home through a 11 step eyesight testing from Lenskart.' }
                ]}
            />
            {hash && <Modal {...modalConfig} >
                <React.Fragment>
                    {!props.isBookingProcessing && <div className="hto-close-btn text-left pd-t15 pd-l10 lh-12"><span className="fsp14 fw500 text-color_grey">{hash === '#view-location' && isMobile ? 'CONFIRM YOUR LOCATION' : ''}</span><span className="fsp18 pd-r10 close-btn" onClick={() => navTo('', hash)}>&#10005;</span></div>}
                    {{
                        '#view-location': <HTOAppointmentLocation couponCode={props.htoConfig.coupon.code} scheduleOrUpdate={scheduleOrUpdate} navTo={navTo} />,
                        '#book-later': <HTOScheduleLater couponCode={props.htoConfig.coupon.code} placeOrder={placeOrder} scheduleOrUpdate={scheduleOrUpdate} navTo={navTo} />,
                        '#book-now': <HTOAppointment isBookingProcessing={props.isBookingProcessing} applyCoupon={props.applyCoupon} couponCode={props.htoConfig.coupon.code} cartData={props.cartData} placeOrder={bookAppointmentNow} navTo={navTo} scheduleOrUpdate={scheduleOrUpdate} />,
                        '#cancel-appointment': <HTOCancelAppointment navTo={navTo} orderId={order && order.id || appointmentInfo && appointmentInfo.orderid} />,
                        '#cancel-appointment-success': <HTOCancelAppointmentSuccess navTo={navTo} orderId={order && order.id} title="Appointment Cancelled!" />,
                        '#confirm-appointment': <HTOAppointmentSuccess navTo={navTo} amount={payment && payment.amount && payment.amount.price || (isOnlinePayment && props.orderDetail.result.amount.total)} orderId={order && order.id || (isOnlinePayment && props.orderDetail.result.id)} appointmentInfo={appointmentInfo} />
                    }[hash]}
                </React.Fragment>
            </Modal>}
            {Boolean(payment && payment.actionInfo) && <div className="display-none">
                <form
                    ref={paymentForm}
                    action={payment.actionInfo.redirectUrl}
                    method="post"
                >
                    {Object.keys(payment.actionInfo.requestParams).map(data => {
                        return (<p key={data}>{data} : <input type="text" name={data} value={payment.actionInfo.requestParams[data]} /></p>);
                    })}
                </form>
            </div>}
            {props.showLoader && <Loader fullpage />}
            {errorMsg && <InfoModalComponent msgContent={errorMsg} callback={noop} />}
        </div>
    );
}

const mapStateToProps = state => {
    const paymentData = state.checkout.paymentData ? state.checkout.paymentData.result : null;
    return {
        showLoader: state.hto.loadingLocationServiceableDetails || state.hto.processingCancelOrder || state.checkout.loadingPlaceOrder,
        htoConfig: state.hto.htoConfig,
        cartData: state.cart.cartData.result,
        paymentData,
        cartDataErr: state.cart.error,
        appointmentInfo: state.hto.appointmentInfo,
        paymentError: state.checkout.paymentError,
        orderDetail: state.order.orderDetails,
        isBookingProcessing: state.hto.isBookingProcessing,
        pincodeData: state.address.pincodeData
    };
};

const mapDispatchToProps = dispatch => ({
    addToCart: data => dispatch(addToCart(data)),
    updateCart: (itemId, data) => dispatch(updateCart(itemId, data)),
    resetCartItem: (itemId, count, flag) => dispatch(updateCartItem(itemId, count, flag)),
    deleteCart: () => dispatch(deleteCart()),
    placeOrder: data => dispatch(orderPayment(data)),
    bookAppointment: (userInfo, utm) => dispatch(bookHTOAppointment({ userInfo, utm })),
    setToastMessage: data => dispatch(setToastMessage(data)),
    applyCoupon: code => dispatch(applyCode(`${config.apiPath.applyGV}${code}?applyWallet=false`, 'post')),
});

export default provideHooks(hooks)(connect(mapStateToProps, mapDispatchToProps)(HTO));
